import { render, staticRenderFns } from "./AddEventDrawer.vue?vue&type=template&id=8b68cd02&scoped=true&lang=pug"
import script from "./AddEventDrawer.vue?vue&type=script&lang=js"
export * from "./AddEventDrawer.vue?vue&type=script&lang=js"
import style0 from "./AddEventDrawer.vue?vue&type=style&index=0&id=8b68cd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b68cd02",
  null
  
)

export default component.exports